export enum NodeTypeWire {
  mega = 'mega',
}
